import React, { useEffect, useState } from "react";

const ItemHolder = ({ onClick, item }) => {
  const [hover, setHover] = useState(false);

  return (
    <div
      onClick={() => onClick(item.key)}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        backgroundColor: "#2f2f2f",
        height: "100%",
        width: "150px",
        cursor: "pointer",
      }}
    >
      <div
        className="textBoldWhite"
        style={{
          color: hover ? "gold" : "white",
          flex: 1,
          textAlign: "center",
        }}
      >
        {item.key}
      </div>
      <div
        className="textWhite"
        style={{ fontSize: "13px", marginRight: "4px" }}
      >
        {item.value}
      </div>
    </div>
  );
};

export default ItemHolder;
